// Mock data for Goodwishes India Tours

export const brand = {
  name: 'Goodwishes India Tours',
  tagline: 'Ghumo India',
  phone1: '+91 70427 07114',
  phone2: '+91 79851 82238',
  phoneRaw: '917985182238',
  email: 'sales@goodwishesindiatours.com',
  website: 'www.goodwishesindiatours.com',
  address: 'Near Hyderabad Gate, BHU University, Susuwahi, Varanasi, Uttar Pradesh',
  facebook: 'https://www.facebook.com/share/1DNf2ZFNmc/',
};

export const whatsappLink = (msg) =>
  `https://wa.me/${brand.phoneRaw}?text=${encodeURIComponent(msg)}`;

export const categories = ['All', 'Spiritual', 'North India', 'South India', 'Hills & Adventure', 'Beaches', 'Nepal'];

const makeItinerary = (days) =>
  days.map((d, i) => ({ day: i + 1, title: d.title, details: d.details }));

export const packages = [
  {
    id: 'varanasi-spiritual',
    title: 'Varanasi Spiritual',
    duration: '2N/3D',
    category: 'Spiritual',
    highlights: 'Ganga Aarti • Kashi Vishwanath • Sarnath • Boat ride • Sankat Mochan',
    inclusions: ['Hotel', 'Pickup', 'Guide', 'Breakfast'],
    image: 'https://images.unsplash.com/photo-1571536802807-30451e3955d8',
    priceFrom: 6999,
    itinerary: makeItinerary([
      { title: 'Arrival & Ganga Aarti at Dashashwamedh Ghat', details: 'Pickup from Varanasi station/airport. Check-in to hotel. Evening witness the world-famous Ganga Aarti at Dashashwamedh Ghat with reserved seating. Overnight in Varanasi.' },
      { title: 'Subah-e-Banaras Boat Ride & Kashi Vishwanath', details: 'Early morning boat ride on Ganga to witness sunrise & burning ghats. Darshan at Kashi Vishwanath Dham (VIP darshan option). Visit Sankat Mochan Hanuman Temple, Durga Kund & BHU. Evening walk at Assi Ghat.' },
      { title: 'Sarnath Excursion & Departure', details: 'Morning drive to Sarnath - Dhamek Stupa, Buddhist Monasteries & Museum. Return, checkout & drop.' },
    ]),
  },
  {
    id: 'ayodhya-darshan',
    title: 'Ayodhya Darshan',
    duration: '1N/2D',
    category: 'Spiritual',
    highlights: 'Ram Janmabhoomi • Hanuman Garhi • Kanak Bhawan • Saryu Aarti',
    inclusions: ['AC Cab', 'Hotel', 'Guide'],
    image: 'https://images.unsplash.com/photo-1652059468417-3b44ff25afdf',
    priceFrom: 5499,
    itinerary: makeItinerary([
      { title: 'Varanasi to Ayodhya & Saryu Aarti', details: 'AC cab pickup from Varanasi (approx 200 km / 5 hrs). Check-in. Evening Saryu Aarti at Ram Ki Paidi. Overnight in Ayodhya.' },
      { title: 'Ram Mandir Darshan & Return', details: 'Early darshan at Ram Janmabhoomi Mandir. Visit Hanuman Garhi, Kanak Bhawan, Nageshwarnath Temple. Return to Varanasi by evening.' },
    ]),
  },
  {
    id: 'prayagraj-sangam',
    title: 'Prayagraj Sangam',
    duration: '1N/2D',
    category: 'Spiritual',
    highlights: 'Triveni Sangam • Anand Bhavan • Akshayavat • Hanuman Temple',
    inclusions: ['Cab', 'Boat', 'Hotel'],
    image: 'https://images.unsplash.com/photo-1708189976990-f785dbb0ac26',
    priceFrom: 4999,
    itinerary: makeItinerary([
      { title: 'Drive to Prayagraj & Sangam Snan', details: 'Morning drive from Varanasi (approx 125 km). Boat ride & holy dip at Triveni Sangam (Ganga-Yamuna-Saraswati). Visit Bade Hanuman Ji & Akshayavat. Hotel check-in.' },
      { title: 'Anand Bhavan, Allahabad Fort & Return', details: 'Visit Anand Bhavan Museum, Allahabad Fort, Khusro Bagh & All Saints Cathedral. Return drop to Varanasi.' },
    ]),
  },
  {
    id: 'chitrakoot-yatra',
    title: 'Chitrakoot Yatra',
    duration: '2N/3D',
    category: 'Spiritual',
    highlights: 'Ramghat • Kamadgiri • Sphatik Shila • Hanuman Dhara • Gupt Godavari',
    inclusions: ['Hotel', 'Cab', 'Guide'],
    image: 'https://images.unsplash.com/photo-1529733772151-bab41484710a',
    priceFrom: 7499,
    itinerary: makeItinerary([
      { title: 'Arrival & Ramghat Aarti', details: 'Pickup from Varanasi / Prayagraj. Drive to Chitrakoot. Evening aarti at Ramghat on Mandakini river.' },
      { title: 'Kamadgiri Parikrama & Sacred Sites', details: 'Kamadgiri Parikrama, Bharat Milap, Hanuman Dhara, Sphatik Shila & Janki Kund darshan.' },
      { title: 'Gupt Godavari & Departure', details: 'Visit Gupt Godavari caves & Anusuya Ashram. Drive back / drop.' },
    ]),
  },
  {
    id: 'naimisharanya',
    title: 'Naimisharanya',
    duration: '1N/2D',
    category: 'Spiritual',
    highlights: 'Chakra Teerth • Dadhichi Kund • Hanuman Garhi • Lalita Devi',
    inclusions: ['Cab', 'Hotel'],
    image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220',
    priceFrom: 5299,
    itinerary: makeItinerary([
      { title: 'Drive to Naimisharanya', details: 'Pickup from Lucknow/Varanasi. Visit Chakra Teerth, holy dip. Evening darshan at Lalita Devi Shakti Peeth.' },
      { title: 'Sacred Sites & Return', details: 'Dadhichi Kund, Hanuman Garhi, Vyas Gaddi & Pandav Kila. Drop.' },
    ]),
  },
  {
    id: 'char-dham-yatra',
    title: 'Char Dham Yatra',
    duration: '10N/11D',
    category: 'Spiritual',
    highlights: 'Yamunotri • Gangotri • Kedarnath • Badrinath with all stops',
    inclusions: ['Hotels', 'Tempo', 'Meals', 'Guide'],
    image: 'https://images.unsplash.com/photo-1712733900711-d0b929d0d7cc',
    priceFrom: 32999,
    itinerary: makeItinerary([
      { title: 'Haridwar Arrival & Ganga Aarti', details: 'Arrival Haridwar/Delhi. Evening Har Ki Pauri Aarti. Overnight Haridwar.' },
      { title: 'Haridwar to Barkot', details: 'Drive via Mussoorie to Barkot (210 km). Overnight Barkot.' },
      { title: 'Yamunotri Dham', details: 'Drive to Janki Chatti. 6 km trek/pony/palki to Yamunotri temple. Return to Barkot.' },
      { title: 'Barkot to Uttarkashi', details: 'Drive to Uttarkashi (100 km). Vishwanath Temple. Overnight.' },
      { title: 'Gangotri Dham', details: 'Drive to Gangotri (100 km). Darshan & aarti. Return to Uttarkashi.' },
      { title: 'Uttarkashi to Guptkashi', details: 'Long drive via Tehri Dam (220 km). Overnight Guptkashi.' },
      { title: 'Kedarnath Yatra', details: 'Drive to Sonprayag / Gaurikund. 18 km trek OR helicopter option to Kedarnath. Darshan & overnight.' },
      { title: 'Return to Guptkashi', details: 'Morning darshan. Return trek/heli to Sonprayag. Drive to Guptkashi.' },
      { title: 'Guptkashi to Badrinath', details: 'Drive via Joshimath to Badrinath (215 km). Evening aarti at Badrinath temple.' },
      { title: 'Badrinath Darshan & Mana Village', details: 'Morning abhishek darshan. Visit Mana - last Indian village, Vyas Gufa, Bheem Pul. Drive to Rudraprayag.' },
      { title: 'Return to Haridwar / Departure', details: 'Drive back to Haridwar via Devprayag. Drop.' },
    ]),
  },
  {
    id: 'kedarnath-yatra',
    title: 'Kedarnath Yatra',
    duration: '4N/5D',
    category: 'Spiritual',
    highlights: 'Haridwar • Guptkashi • Kedarnath • Rudraprayag return',
    inclusions: ['Hotel', 'Cab', 'Helicopter option'],
    image: 'https://images.pexels.com/photos/16152405/pexels-photo-16152405.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    priceFrom: 15999,
    itinerary: makeItinerary([
      { title: 'Arrival Haridwar', details: 'Pickup, evening Ganga Aarti at Har Ki Pauri. Overnight.' },
      { title: 'Haridwar to Guptkashi', details: 'Drive via Devprayag & Rudraprayag (215 km). Overnight.' },
      { title: 'Kedarnath Darshan', details: 'Drive to Sonprayag. Trek 18 km / pony / helicopter to Kedarnath. Overnight near temple.' },
      { title: 'Return to Rudraprayag', details: 'Darshan & return trek/heli. Drive to Rudraprayag/Srinagar.' },
      { title: 'Rudraprayag to Haridwar & Departure', details: 'Drive back to Haridwar. Drop at Rishikesh/Haridwar/Dehradun.' },
    ]),
  },
  {
    id: 'badrinath-yatra',
    title: 'Badrinath Yatra',
    duration: '3N/4D',
    category: 'Spiritual',
    highlights: 'Haridwar • Joshimath • Badrinath • Mana Village',
    inclusions: ['Hotel', 'Cab', 'Guide'],
    image: 'https://images.unsplash.com/photo-1683596449112-ed107371dfaf',
    priceFrom: 13999,
    itinerary: makeItinerary([
      { title: 'Haridwar Arrival', details: 'Har Ki Pauri Aarti. Overnight.' },
      { title: 'Haridwar to Joshimath', details: 'Drive via Devprayag, Rudraprayag & Karnaprayag (250 km). Narsingh Temple.' },
      { title: 'Joshimath to Badrinath', details: 'Drive to Badrinath (45 km). Darshan, Tapt Kund. Visit Mana Village. Return Joshimath.' },
      { title: 'Return to Haridwar', details: 'Long drive back to Haridwar. Departure.' },
    ]),
  },
  {
    id: 'kashmir-paradise',
    title: 'Kashmir Paradise',
    duration: '5N/6D',
    category: 'Hills & Adventure',
    highlights: 'Srinagar • Gulmarg • Pahalgam • Dal Lake Shikara • Mughal Gardens',
    inclusions: ['Hotels', 'Cab', 'Shikara', 'Breakfast'],
    image: 'https://images.unsplash.com/photo-1707381076957-ec19b90e9cbe',
    priceFrom: 18999,
    itinerary: makeItinerary([
      { title: 'Arrival Srinagar & Shikara', details: 'Airport pickup. Shikara ride on Dal Lake. Check-in houseboat/hotel.' },
      { title: 'Srinagar Local Sightseeing', details: 'Mughal Gardens - Nishat, Shalimar, Chashme Shahi. Shankaracharya Temple. Hazratbal.' },
      { title: 'Srinagar to Gulmarg', details: 'Drive to Gulmarg (55 km). Gondola Phase 1 & 2 (optional). Snow activities.' },
      { title: 'Gulmarg to Pahalgam', details: 'Drive to Pahalgam via Awantipura ruins & Saffron fields (140 km). Betaab & Aru Valley (optional local cab).' },
      { title: 'Pahalgam to Srinagar', details: 'Chandanwari, Baisaran (mini Switzerland). Return to Srinagar. Shopping.' },
      { title: 'Departure', details: 'Airport drop.' },
    ]),
  },
  {
    id: 'shimla-manali',
    title: 'Shimla–Manali',
    duration: '5N/6D',
    category: 'Hills & Adventure',
    highlights: 'Shimla Mall Road • Kufri • Manali • Solang • Rohtang (seasonal)',
    inclusions: ['Hotels', 'Cab', 'Breakfast'],
    image: 'https://images.unsplash.com/photo-1657894736581-ccc35d62d9e2',
    priceFrom: 16999,
    itinerary: makeItinerary([
      { title: 'Chandigarh/Delhi to Shimla', details: 'Drive to Shimla (approx 6-7 hrs). Mall Road walk & Ridge.' },
      { title: 'Shimla - Kufri', details: 'Kufri excursion, Jakhu Temple, Christ Church.' },
      { title: 'Shimla to Manali', details: 'Long drive via Kullu (250 km). Overnight.' },
      { title: 'Manali Local', details: 'Hadimba Temple, Vashisht Kund, Manu Temple, Mall Road.' },
      { title: 'Solang / Rohtang / Atal Tunnel', details: 'Snow point excursion (seasonal). Adventure activities.' },
      { title: 'Manali to Chandigarh/Delhi', details: 'Drive back for departure.' },
    ]),
  },
  {
    id: 'dharamshala-mcleod',
    title: 'Dharamshala–McLeod',
    duration: '3N/4D',
    category: 'Hills & Adventure',
    highlights: 'Dalai Lama Temple • Bhagsu Falls • Triund trek option • Cricket Stadium',
    inclusions: ['Hotel', 'Cab'],
    image: 'https://images.unsplash.com/photo-1648938287449-bc1fb7536c9f',
    priceFrom: 11999,
    itinerary: makeItinerary([
      { title: 'Arrival Dharamshala', details: 'Pickup from Pathankot/Delhi. Cricket Stadium & War Memorial.' },
      { title: 'McLeodganj Sightseeing', details: 'Dalai Lama Temple (Tsuglagkhang), Bhagsunag Falls, Dal Lake, Naddi View Point.' },
      { title: 'Triund Trek (Optional)', details: 'Full day trek to Triund with packed lunch OR relaxed cafe day in McLeodganj.' },
      { title: 'Departure', details: 'Kangra Fort en route drop.' },
    ]),
  },
  {
    id: 'leh-ladakh',
    title: 'Leh–Ladakh',
    duration: '6N/7D',
    category: 'Hills & Adventure',
    highlights: 'Leh • Nubra • Pangong • Khardung La • Monasteries',
    inclusions: ['Hotels', 'Cab', 'Permits', 'Oxygen'],
    image: 'https://images.unsplash.com/photo-1606857090627-27ca46667290',
    priceFrom: 27999,
    itinerary: makeItinerary([
      { title: 'Arrival Leh (Acclimatization)', details: 'Airport pickup. Full rest for acclimatization at 11,500 ft.' },
      { title: 'Leh Local Sightseeing', details: 'Shanti Stupa, Leh Palace, Hall of Fame, Sangam viewpoint, Magnetic Hill, Gurudwara Pathar Sahib.' },
      { title: 'Leh to Nubra via Khardung La', details: 'Drive via world\'s highest motorable pass Khardung La (18,380 ft). Diskit Monastery, Hunder sand dunes, camel ride.' },
      { title: 'Nubra to Pangong via Shyok', details: 'Direct route to Pangong Tso via Shyok. Overnight camp at Pangong.' },
      { title: 'Pangong to Leh', details: 'Sunrise at Pangong. Drive back via Chang La pass. Thiksey & Hemis Monastery.' },
      { title: 'Leh Free Day / Shopping', details: 'Leisure day. Local market shopping.' },
      { title: 'Departure', details: 'Airport drop.' },
    ]),
  },
  {
    id: 'rajasthan-circuit',
    title: 'Rajasthan Circuit',
    duration: '6N/7D',
    category: 'North India',
    highlights: 'Jaipur • Udaipur • Jaisalmer • Mount Abu • Desert Safari',
    inclusions: ['Hotels', 'Cab', 'Camel Safari'],
    image: 'https://images.unsplash.com/photo-1605944087400-8a5992d7b066',
    priceFrom: 22999,
    itinerary: makeItinerary([
      { title: 'Arrival Jaipur', details: 'Pickup. Evening Hawa Mahal drive-by & Chokhi Dhani cultural dinner.' },
      { title: 'Jaipur Sightseeing', details: 'Amber Fort with elephant ride, City Palace, Jantar Mantar, Jal Mahal.' },
      { title: 'Jaipur to Udaipur', details: 'Drive via Pushkar (Brahma Temple). Reach Udaipur by evening.' },
      { title: 'Udaipur Sightseeing', details: 'City Palace, Jagdish Temple, Sahelion ki Bari, evening boat ride on Lake Pichola.' },
      { title: 'Udaipur to Jaisalmer', details: 'Drive via Ranakpur Jain Temple. Overnight Jaisalmer.' },
      { title: 'Jaisalmer Fort & Desert Camp', details: 'Golden Fort, Patwon ki Haveli, Gadisar Lake. Sam sand dunes camel safari & cultural night in desert camp.' },
      { title: 'Departure via Jodhpur', details: 'Drive to Jodhpur. Mehrangarh Fort visit & departure.' },
    ]),
  },
  {
    id: 'agra-delhi-jaipur',
    title: 'Agra–Delhi–Jaipur (Golden Triangle)',
    duration: '4N/5D',
    category: 'North India',
    highlights: 'Taj Mahal • Red Fort • Amber Fort • City Palace • Qutub Minar',
    inclusions: ['Hotels', 'Cab', 'Guide'],
    image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523',
    priceFrom: 14999,
    itinerary: makeItinerary([
      { title: 'Arrival Delhi', details: 'Airport pickup. India Gate drive-by. Overnight.' },
      { title: 'Delhi Sightseeing', details: 'Red Fort, Jama Masjid, Raj Ghat, Qutub Minar, Lotus Temple, Akshardham.' },
      { title: 'Delhi to Agra', details: 'Drive on Yamuna Expressway. Taj Mahal sunset view & Agra Fort.' },
      { title: 'Agra to Jaipur via Fatehpur Sikri', details: 'UNESCO Fatehpur Sikri. Reach Jaipur.' },
      { title: 'Jaipur Sightseeing & Departure', details: 'Amber Fort, City Palace, Hawa Mahal photo stop, Jantar Mantar. Drop.' },
    ]),
  },
  {
    id: 'amritsar-golden',
    title: 'Amritsar Golden',
    duration: '2N/3D',
    category: 'Spiritual',
    highlights: 'Golden Temple • Wagah Border • Jallianwala • Partition Museum',
    inclusions: ['Hotel', 'Cab'],
    image: 'https://images.unsplash.com/photo-1623059508779-2542c6e83753',
    priceFrom: 8999,
    itinerary: makeItinerary([
      { title: 'Arrival & Golden Temple', details: 'Pickup. Evening darshan at Sri Harmandir Sahib & langar seva.' },
      { title: 'Wagah Border & Jallianwala Bagh', details: 'Morning Jallianwala Bagh & Partition Museum. Evening Wagah Border ceremony.' },
      { title: 'Durgiana Temple & Departure', details: 'Morning Durgiana Temple, Ram Tirath. Drop.' },
    ]),
  },
  {
    id: 'haridwar-rishikesh',
    title: 'Haridwar–Rishikesh',
    duration: '2N/3D',
    category: 'Spiritual',
    highlights: 'Har Ki Pauri Aarti • Laxman Jhula • Beatles Ashram • River Rafting',
    inclusions: ['Hotel', 'Cab', 'Rafting option'],
    image: 'https://images.unsplash.com/photo-1718383538535-49ff3dd8c550',
    priceFrom: 7499,
    itinerary: makeItinerary([
      { title: 'Arrival Haridwar & Aarti', details: 'Pickup. Ganga snan. Evening Har Ki Pauri aarti.' },
      { title: 'Haridwar to Rishikesh', details: 'Mansa Devi & Chandi Devi (ropeway). Drive to Rishikesh. Laxman Jhula, Ram Jhula, Triveni Ghat aarti, Beatles Ashram.' },
      { title: 'River Rafting & Departure', details: 'Optional 16 km rafting Shivpuri to Rishikesh. Drop.' },
    ]),
  },
  {
    id: 'goa-beaches',
    title: 'Goa Beaches',
    duration: '4N/5D',
    category: 'Beaches',
    highlights: 'North & South Goa beaches • Fort Aguada • Nightlife • Water sports',
    inclusions: ['Hotels', 'Cab', 'Breakfast'],
    image: 'https://images.pexels.com/photos/28520254/pexels-photo-28520254.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    priceFrom: 13999,
    itinerary: makeItinerary([
      { title: 'Arrival Goa', details: 'Airport/station pickup. Check-in North Goa hotel. Evening at Baga/Calangute beach.' },
      { title: 'North Goa Sightseeing', details: 'Fort Aguada, Calangute, Baga, Anjuna, Vagator beaches. Water sports at Baga. Night at Tito\'s / Mambos.' },
      { title: 'South Goa Sightseeing', details: 'Colva, Palolem beaches, Basilica of Bom Jesus, Se Cathedral, Dona Paula.' },
      { title: 'Cruise & Leisure', details: 'Free morning. Evening Mandovi River Sunset Cruise with cultural show.' },
      { title: 'Departure', details: 'Airport drop.' },
    ]),
  },
  {
    id: 'kerala-backwaters',
    title: 'Kerala Backwaters',
    duration: '5N/6D',
    category: 'South India',
    highlights: 'Munnar • Thekkady • Alleppey Houseboat • Kochi Fort',
    inclusions: ['Hotels', 'Houseboat', 'Cab'],
    image: 'https://images.pexels.com/photos/30778230/pexels-photo-30778230.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    priceFrom: 19999,
    itinerary: makeItinerary([
      { title: 'Cochin Arrival', details: 'Airport pickup. Fort Kochi, Chinese fishing nets, Jew Town.' },
      { title: 'Cochin to Munnar', details: 'Drive via Cheeyappara Falls (130 km). Tea gardens.' },
      { title: 'Munnar Sightseeing', details: 'Eravikulam National Park, Mattupetty Dam, Echo Point, Tea Museum.' },
      { title: 'Munnar to Thekkady', details: 'Drive to Thekkady (110 km). Periyar Wildlife boat safari, Kathakali & Kalari show.' },
      { title: 'Thekkady to Alleppey Houseboat', details: 'Drive to Alleppey. Overnight houseboat with all meals cruising the backwaters.' },
      { title: 'Alleppey to Cochin & Departure', details: 'Disembark & drive to airport.' },
    ]),
  },
  {
    id: 'ooty-kodaikanal',
    title: 'Ooty–Kodaikanal',
    duration: '4N/5D',
    category: 'South India',
    highlights: 'Ooty Lake • Botanical Garden • Coonoor • Kodaikanal Lake • Pillar Rocks',
    inclusions: ['Hotels', 'Cab'],
    image: 'https://images.unsplash.com/photo-1674498260932-6f7d8eed6d9f',
    priceFrom: 15999,
    itinerary: makeItinerary([
      { title: 'Arrival Ooty', details: 'Coimbatore/Bangalore pickup. Drive to Ooty. Botanical Gardens.' },
      { title: 'Ooty & Coonoor', details: 'Doddabetta Peak, Ooty Lake boating, Coonoor, Sim\'s Park, Tea Factory.' },
      { title: 'Ooty to Kodaikanal', details: 'Long scenic drive (250 km). Evening Kodai Lake.' },
      { title: 'Kodaikanal Sightseeing', details: 'Pillar Rocks, Guna Cave, Coaker\'s Walk, Bryant Park, Silver Cascade Falls.' },
      { title: 'Departure', details: 'Drive down to Madurai / Coimbatore.' },
    ]),
  },
  {
    id: 'mysore-coorg',
    title: 'Mysore–Coorg',
    duration: '4N/5D',
    category: 'South India',
    highlights: 'Mysore Palace • Brindavan • Coorg Coffee estates • Abbey Falls',
    inclusions: ['Hotels', 'Cab'],
    image: 'https://images.unsplash.com/photo-1659126574791-13313aa424bd',
    priceFrom: 14999,
    itinerary: makeItinerary([
      { title: 'Arrival Mysore', details: 'Bangalore pickup. Drive to Mysore. Chamundi Hills.' },
      { title: 'Mysore Sightseeing', details: 'Mysore Palace, Zoo, St. Philomena Church, Brindavan Gardens musical fountain.' },
      { title: 'Mysore to Coorg', details: 'Drive to Coorg via Kushalnagar. Golden Temple (Bylakuppe) & Nisargadhama.' },
      { title: 'Coorg Sightseeing', details: 'Abbey Falls, Raja\'s Seat, Talakaveri, Bhagamandala, Coffee plantation walk.' },
      { title: 'Departure', details: 'Return to Bangalore/Mangalore.' },
    ]),
  },
  {
    id: 'andaman-islands',
    title: 'Andaman Islands',
    duration: '5N/6D',
    category: 'Beaches',
    highlights: 'Port Blair • Havelock • Neil Island • Cellular Jail • Scuba option',
    inclusions: ['Hotels', 'Ferry', 'Transfers'],
    image: 'https://images.unsplash.com/photo-1704314315344-cd10b9779ce6',
    priceFrom: 24999,
    itinerary: makeItinerary([
      { title: 'Arrival Port Blair', details: 'Corbyn\'s Cove Beach. Evening Cellular Jail Light & Sound show.' },
      { title: 'Port Blair - Ross & North Bay', details: 'Ferry to Ross Island (ruins) & North Bay (snorkeling / glass boat).' },
      { title: 'Port Blair to Havelock', details: 'Ferry to Havelock. Radhanagar Beach (Asia\'s best beach) at sunset.' },
      { title: 'Havelock - Elephant Beach', details: 'Elephant Beach with water sports / scuba diving option. Kalapathar Beach evening.' },
      { title: 'Havelock to Neil to Port Blair', details: 'Neil Island - Bharatpur, Laxmanpur, Natural Bridge. Ferry back to Port Blair.' },
      { title: 'Chidiya Tapu & Departure', details: 'Sunset point Chidiya Tapu. Airport drop.' },
    ]),
  },
  {
    id: 'darjeeling-gangtok',
    title: 'Darjeeling–Gangtok',
    duration: '5N/6D',
    category: 'Hills & Adventure',
    highlights: 'Tiger Hill • Tea Gardens • MG Road • Tsomgo Lake • Baba Mandir',
    inclusions: ['Hotels', 'Cab', 'Permits'],
    image: 'https://images.unsplash.com/photo-1620903376453-25f5a6fd533e',
    priceFrom: 17999,
    itinerary: makeItinerary([
      { title: 'NJP to Darjeeling', details: 'Pickup from Bagdogra/NJP. Drive to Darjeeling.' },
      { title: 'Tiger Hill Sunrise', details: 'Early Tiger Hill for Kanchenjunga sunrise. Ghoom Monastery, Batasia Loop, Japanese Peace Pagoda, HMI, Tea Estate.' },
      { title: 'Darjeeling to Gangtok', details: 'Drive to Gangtok (100 km). Evening MG Marg walk.' },
      { title: 'Tsomgo Lake & Baba Mandir', details: 'Full day excursion to Tsomgo Lake (12,400 ft) & Baba Harbhajan Mandir (permit required).' },
      { title: 'Gangtok Local Sightseeing', details: 'Rumtek Monastery, Enchey Monastery, Ban Jhakri Falls, Ropeway.' },
      { title: 'Departure via NJP', details: 'Drive down for train/flight.' },
    ]),
  },
  {
    id: 'puri-konark',
    title: 'Puri–Konark–Bhubaneswar',
    duration: '3N/4D',
    category: 'Spiritual',
    highlights: 'Jagannath Temple • Sun Temple • Lingaraj • Chilika Lake',
    inclusions: ['Hotels', 'Cab', 'Guide'],
    image: 'https://images.unsplash.com/photo-1706790574525-d218c4c52b5c',
    priceFrom: 10999,
    itinerary: makeItinerary([
      { title: 'Arrival Puri', details: 'Bhubaneswar pickup. Drive to Puri. Evening Jagannath Temple darshan.' },
      { title: 'Puri - Konark - Chilika', details: 'Sun Temple Konark (UNESCO). Chilika Lake dolphin boat ride (optional).' },
      { title: 'Bhubaneswar Temples', details: 'Lingaraj, Mukteshwar, Rajarani, Udayagiri Khandagiri caves.' },
      { title: 'Departure', details: 'Airport/station drop.' },
    ]),
  },
  {
    id: 'meghalaya-assam',
    title: 'Meghalaya–Assam',
    duration: '5N/6D',
    category: 'Hills & Adventure',
    highlights: 'Shillong • Cherrapunji • Living Root Bridges • Kaziranga option',
    inclusions: ['Hotels', 'Cab'],
    image: 'https://images.unsplash.com/photo-1637043765564-a071ff91a09f',
    priceFrom: 18999,
    itinerary: makeItinerary([
      { title: 'Guwahati Arrival', details: 'Pickup, Kamakhya Temple, Umananda Island. Overnight Guwahati.' },
      { title: 'Guwahati to Shillong', details: 'Drive via Umiam Lake. Ward\'s Lake, Police Bazaar.' },
      { title: 'Shillong to Cherrapunji', details: 'Elephant Falls, Mawkdok view, Seven Sister Falls, Nohkalikai Falls, Mawsmai caves.' },
      { title: 'Living Root Bridge Trek', details: 'Trek to Double Decker Living Root Bridge Nongriat OR visit Mawlynnong (cleanest village) & Dawki river.' },
      { title: 'Shillong to Kaziranga (optional) / Guwahati', details: 'Kaziranga jeep safari option OR back to Guwahati for shopping.' },
      { title: 'Departure', details: 'Airport drop.' },
    ]),
  },
  {
    id: 'rann-of-kutch',
    title: 'Rann of Kutch',
    duration: '3N/4D',
    category: 'North India',
    highlights: 'White Rann • Kala Dungar • Handicraft villages • Full moon option',
    inclusions: ['Tent/Hotel', 'Cab'],
    image: 'https://images.unsplash.com/photo-1628265512314-a9464859fe0c',
    priceFrom: 12999,
    itinerary: makeItinerary([
      { title: 'Bhuj Arrival', details: 'Airport pickup. Aina Mahal, Prag Mahal, Bhujodi handicraft village.' },
      { title: 'Bhuj to Dhordo (White Rann)', details: 'Drive to Rann Utsav tent city. Camel/ATV ride. Sunset at White Rann.' },
      { title: 'Kala Dungar & Villages', details: 'Highest point Kala Dungar, India Bridge, visit Ludiya & Hodka handicraft villages.' },
      { title: 'Return & Departure', details: 'Return to Bhuj. Airport drop.' },
    ]),
  },
  {
    id: 'ajanta-ellora',
    title: 'Ajanta–Ellora',
    duration: '2N/3D',
    category: 'North India',
    highlights: 'Ajanta Caves • Ellora Caves • Daulatabad Fort • Aurangabad',
    inclusions: ['Hotel', 'Cab', 'Guide'],
    image: 'https://images.unsplash.com/photo-1572461275348-bf5edc4e4ef9',
    priceFrom: 9999,
    itinerary: makeItinerary([
      { title: 'Arrival Aurangabad', details: 'Pickup. Bibi ka Maqbara, Panchakki. Overnight.' },
      { title: 'Ellora & Daulatabad', details: 'Ellora Caves (UNESCO) - Kailasa temple. Daulatabad Fort. Grishneshwar Jyotirlinga.' },
      { title: 'Ajanta Caves & Departure', details: 'Full day Ajanta caves (100 km). Return & drop.' },
    ]),
  },
  {
    id: 'khajuraho-orchha',
    title: 'Khajuraho–Orchha',
    duration: '2N/3D',
    category: 'North India',
    highlights: 'Western Group Temples • Light & Sound • Orchha Fort • Ram Raja',
    inclusions: ['Hotel', 'Cab'],
    image: 'https://images.unsplash.com/photo-1606298855672-3efb63017be8',
    priceFrom: 8999,
    itinerary: makeItinerary([
      { title: 'Khajuraho Arrival', details: 'Pickup. Western Group Temples (UNESCO). Evening Light & Sound show.' },
      { title: 'Khajuraho to Orchha', details: 'Drive (170 km). Ram Raja Temple, Orchha Fort, Chhatris on Betwa river.' },
      { title: 'Orchha Departure', details: 'Jahangir Mahal, Laxminarayan Temple. Drop at Jhansi/Gwalior.' },
    ]),
  },
  {
    id: 'ranthambore-safari',
    title: 'Ranthambore Safari',
    duration: '2N/3D',
    category: 'Hills & Adventure',
    highlights: 'Jungle Safari • Zone entry • Fort view • Wildlife photography',
    inclusions: ['Resort', 'Safari', 'Cab'],
    image: 'https://images.unsplash.com/photo-1586617356423-52763004deac',
    priceFrom: 11999,
    itinerary: makeItinerary([
      { title: 'Arrival Ranthambore', details: 'Sawai Madhopur station pickup. Check-in. Evening safari (Gypsy/Canter).' },
      { title: 'Full Day Safaris', details: 'Morning & evening jungle safaris across zones. Wildlife photography.' },
      { title: 'Ranthambore Fort & Departure', details: 'Ranthambore Fort & Trinetra Ganesh Temple. Drop.' },
    ]),
  },
  {
    id: 'jim-corbett',
    title: 'Jim Corbett',
    duration: '2N/3D',
    category: 'Hills & Adventure',
    highlights: 'Jeep Safari • River side resort • Bird watching • Nature walk',
    inclusions: ['Resort', 'Safari', 'Meals'],
    image: 'https://images.unsplash.com/photo-1508817628294-5a453fa0b8fb',
    priceFrom: 10999,
    itinerary: makeItinerary([
      { title: 'Arrival Corbett', details: 'Delhi/Ramnagar pickup. Riverside resort check-in. Evening nature walk.' },
      { title: 'Jeep Safari', details: 'Early morning jeep safari (Bijrani/Jhirna/Dhikala zones). Evening bird watching.' },
      { title: 'Corbett Fall & Departure', details: 'Corbett Waterfall, Garjia Temple. Drop.' },
    ]),
  },
  {
    id: 'guwahati',
    title: 'Guwahati',
    duration: '3N/4D',
    category: 'Spiritual',
    highlights: 'Kamakhya • Umananda • Assam State Museum • Brahmaputra Cruise • Pobitora',
    inclusions: ['Hotel', 'Cab', 'Guide', 'Breakfast'],
    image: 'https://images.unsplash.com/photo-1704803269149-1fe5f14be460',
    priceFrom: 12999,
    itinerary: makeItinerary([
      { title: 'Guwahati Arrival', details: 'Pickup. Kamakhya Devi Shakti Peeth darshan.' },
      { title: 'Local Sightseeing', details: 'Umananda Island (boat), Basistha Ashram, Assam State Museum, Fancy Bazaar.' },
      { title: 'Pobitora Wildlife & River Cruise', details: 'Half day Pobitora one-horned rhino safari. Evening Brahmaputra river cruise with cultural show.' },
      { title: 'Departure', details: 'Airport/station drop.' },
    ]),
  },
  // ---- Additional India packages ----
  {
    id: 'vaishno-devi',
    title: 'Vaishno Devi Yatra',
    duration: '2N/3D',
    category: 'Spiritual',
    highlights: 'Katra • Bhawan Darshan • Bhairon Baba • Ardhkuwari • Helicopter option',
    inclusions: ['Hotel', 'Cab', 'Helicopter option'],
    image: 'https://images.unsplash.com/photo-1717502713522-543a97e13dab',
    priceFrom: 8999,
    itinerary: makeItinerary([
      { title: 'Arrival Katra', details: 'Pickup from Jammu / Katra station. Hotel check-in. Yatra parchi (RFID) arrangement.' },
      { title: 'Mata Vaishno Devi Darshan', details: 'Trek 13 km / pony / helicopter to Bhawan. Darshan of Mata & Bhairon Baba Temple. Return to Katra.' },
      { title: 'Local Sightseeing & Departure', details: 'Nau Devi Temple, Baba Dhansar. Drop at Jammu.' },
    ]),
  },
  {
    id: 'shirdi-sai',
    title: 'Shirdi Sai Baba Yatra',
    duration: '2N/3D',
    category: 'Spiritual',
    highlights: 'Sai Samadhi • Dwarkamai • Chavadi • Shani Shingnapur • Nashik',
    inclusions: ['Hotel', 'Cab', 'VIP Darshan'],
    image: 'https://images.unsplash.com/photo-1598090216740-eb040d8c3f82',
    priceFrom: 9999,
    itinerary: makeItinerary([
      { title: 'Arrival Shirdi', details: 'Pickup from Mumbai / Nashik / Shirdi airport. Sai Baba Samadhi darshan.' },
      { title: 'Shirdi Darshan & Shani Shingnapur', details: 'VIP darshan, Dwarkamai, Chavadi, Gurusthan. Excursion to Shani Shingnapur.' },
      { title: 'Nashik Trimbakeshwar & Departure', details: 'Trimbakeshwar Jyotirlinga, Panchvati, Kalaram Temple. Drop at Nashik/Mumbai.' },
    ]),
  },
  {
    id: 'tirupati-balaji',
    title: 'Tirupati Balaji Darshan',
    duration: '2N/3D',
    category: 'Spiritual',
    highlights: 'Tirumala Balaji VIP Darshan • Padmavathi Temple • Kanipakam',
    inclusions: ['Hotel', 'Cab', 'VIP Seva'],
    image: 'https://images.unsplash.com/photo-1733805569204-41768c7d8c0f',
    priceFrom: 11999,
    itinerary: makeItinerary([
      { title: 'Arrival Tirupati', details: 'Pickup from Tirupati/Chennai/Bangalore. Darshan Padmavathi Devi Temple, Tiruchanoor.' },
      { title: 'Tirumala Balaji Darshan', details: 'Early morning drive to Tirumala. VIP Rs.300 darshan of Lord Venkateswara. Prasadam. Return Tirupati.' },
      { title: 'Kanipakam & Departure', details: 'Kanipakam Vinayaka Temple, Sri Kalahasti. Drop.' },
    ]),
  },
  {
    id: 'somnath-dwarka',
    title: 'Somnath–Dwarka (Gujarat)',
    duration: '4N/5D',
    category: 'Spiritual',
    highlights: 'Somnath Jyotirlinga • Dwarkadhish • Bet Dwarka • Nageshwar • Porbandar',
    inclusions: ['Hotels', 'Cab', 'Guide'],
    image: 'https://images.unsplash.com/photo-1735192683815-d8918aad53dc',
    priceFrom: 16999,
    itinerary: makeItinerary([
      { title: 'Arrival Ahmedabad / Rajkot', details: 'Pickup and drive to Somnath (via Junagadh).' },
      { title: 'Somnath Darshan', details: 'First Jyotirlinga darshan, Triveni Sangam, Bhalka Tirth, evening Light & Sound show.' },
      { title: 'Somnath to Dwarka via Porbandar', details: 'En route Kirti Mandir (Gandhi Birthplace). Reach Dwarka. Evening Dwarkadhish aarti.' },
      { title: 'Bet Dwarka & Nageshwar', details: 'Bet Dwarka by boat, Nageshwar Jyotirlinga, Rukmini Devi Temple, Gopi Talav.' },
      { title: 'Departure', details: 'Drive to Jamnagar/Rajkot airport.' },
    ]),
  },
  {
    id: 'rameshwaram-madurai',
    title: 'Rameshwaram–Madurai',
    duration: '3N/4D',
    category: 'Spiritual',
    highlights: 'Ramanathaswamy Jyotirlinga • Dhanushkodi • Meenakshi Temple',
    inclusions: ['Hotels', 'Cab', 'Guide'],
    image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220',
    priceFrom: 12999,
    itinerary: makeItinerary([
      { title: 'Arrival Madurai', details: 'Pickup. Evening Meenakshi Amman Temple aarti & bed ritual ceremony.' },
      { title: 'Madurai to Rameshwaram', details: 'Drive to Rameshwaram (170 km). Pamban Bridge photo stop. Evening darshan.' },
      { title: 'Rameshwaram Darshan & Dhanushkodi', details: '22 Theertham snan at Ramanathaswamy Temple. Dhanushkodi ghost town & Ram Setu view point.' },
      { title: 'Return & Departure', details: 'Drive back to Madurai. Drop.' },
    ]),
  },
  {
    id: 'kanyakumari-trivandrum',
    title: 'Kanyakumari–Trivandrum',
    duration: '3N/4D',
    category: 'South India',
    highlights: 'Kanyakumari Sunrise • Vivekananda Rock • Padmanabhaswamy • Kovalam Beach',
    inclusions: ['Hotels', 'Cab', 'Ferry'],
    image: 'https://images.unsplash.com/photo-1610902552120-c577dbde88a8',
    priceFrom: 13999,
    itinerary: makeItinerary([
      { title: 'Arrival Kanyakumari', details: 'Pickup Trivandrum airport. Drive to Kanyakumari. Sunset at Triveni Sangam.' },
      { title: 'Sunrise & Rock Memorial', details: 'Sunrise at Kanyakumari. Ferry to Vivekananda Rock Memorial & Thiruvalluvar Statue. Suchindram Temple.' },
      { title: 'Kanyakumari to Trivandrum', details: 'Drive to Trivandrum. Padmanabhaswamy Temple darshan. Evening Kovalam Beach.' },
      { title: 'Departure', details: 'Airport drop.' },
    ]),
  },
  {
    id: 'mahabaleshwar-panchgani',
    title: 'Mahabaleshwar–Panchgani',
    duration: '3N/4D',
    category: 'Hills & Adventure',
    highlights: 'Venna Lake • Table Land • Arthur\u2019s Seat • Strawberry Farms • Pratapgad Fort',
    inclusions: ['Hotels', 'Cab', 'Breakfast'],
    image: 'https://images.unsplash.com/photo-1618805714320-f8825019c1be',
    priceFrom: 11999,
    itinerary: makeItinerary([
      { title: 'Arrival Mahabaleshwar', details: 'Pickup from Pune/Mumbai. Venna Lake boating.' },
      { title: 'Mahabaleshwar Sightseeing', details: 'Wilson Point, Arthur\u2019s Seat, Lingmala Falls, Elephant Head Point, strawberry farm visit.' },
      { title: 'Panchgani & Pratapgad', details: 'Table Land Panchgani, Sydney Point, Parsi Point. Pratapgad Fort excursion.' },
      { title: 'Departure', details: 'Drive back for departure.' },
    ]),
  },
  {
    id: 'nainital-mussoorie',
    title: 'Nainital\u2013Mussoorie',
    duration: '5N/6D',
    category: 'Hills & Adventure',
    highlights: 'Naini Lake • Snow View • Kempty Falls • Mall Road • Lal Tibba',
    inclusions: ['Hotels', 'Cab', 'Breakfast'],
    image: 'https://images.unsplash.com/photo-1610715936287-6c2ad208cdbf',
    priceFrom: 15999,
    itinerary: makeItinerary([
      { title: 'Arrival Nainital', details: 'Pickup Delhi/Kathgodam. Drive to Nainital. Evening Naini Lake boating.' },
      { title: 'Nainital Sightseeing', details: 'Snow View, Naina Devi Temple, Tiffin Top, Cave Garden, Sattal & Bhimtal excursion.' },
      { title: 'Nainital to Mussoorie', details: 'Long scenic drive (330 km) via Kaladhungi & Haldwani. Overnight Mussoorie.' },
      { title: 'Mussoorie Sightseeing', details: 'Kempty Falls, Gun Hill Ropeway, Lal Tibba, Mall Road, Company Garden.' },
      { title: 'Dhanaulti & Surkanda Devi', details: 'Excursion to Dhanaulti Eco Park & Surkanda Devi Temple.' },
      { title: 'Departure', details: 'Drive to Dehradun/Delhi for departure.' },
    ]),
  },
  {
    id: 'auli-uttarakhand',
    title: 'Auli Snow & Ski',
    duration: '4N/5D',
    category: 'Hills & Adventure',
    highlights: 'Auli Ropeway • Skiing • Joshimath • Chenab Lake • Nanda Devi views',
    inclusions: ['Hotels', 'Cab', 'Ropeway', 'Ski gear'],
    image: 'https://images.unsplash.com/photo-1689354376922-3977230082da',
    priceFrom: 17999,
    itinerary: makeItinerary([
      { title: 'Haridwar/Rishikesh Arrival', details: 'Pickup, drive to Rudraprayag. Overnight.' },
      { title: 'Drive to Auli via Joshimath', details: 'Scenic drive via Karnaprayag. Ropeway from Joshimath to Auli.' },
      { title: 'Skiing & Snow Fun', details: 'Full day skiing lessons (seasonal Dec-Mar), Chair lift, GMVN gondola. Chenab Lake trek.' },
      { title: 'Auli to Rishikesh', details: 'Drive back with photo stops at Panch Prayags.' },
      { title: 'Departure', details: 'Drop at Haridwar/Dehradun.' },
    ]),
  },
  {
    id: 'spiti-valley',
    title: 'Spiti Valley Circuit',
    duration: '7N/8D',
    category: 'Hills & Adventure',
    highlights: 'Kaza • Key Monastery • Chandratal • Kunzum Pass • Langza Buddha',
    inclusions: ['Hotels/Homestay', 'Cab', 'Permits', 'Oxygen'],
    image: 'https://images.unsplash.com/photo-1579531403068-8d6fd2b3f45d',
    priceFrom: 23999,
    itinerary: makeItinerary([
      { title: 'Shimla Arrival', details: 'Pickup Chandigarh/Shimla. Overnight Shimla.' },
      { title: 'Shimla to Sangla (Kinnaur)', details: 'Drive to Sangla via Kufri, Narkanda, Rampur (230 km). Baspa river.' },
      { title: 'Sangla to Kalpa', details: 'Chitkul (last Indian village), Kalpa \u2013 Kinner Kailash view.' },
      { title: 'Kalpa to Tabo / Nako', details: 'Nako lake, Gue Mummy monastery, Tabo Monastery (1000+ years old).' },
      { title: 'Tabo to Kaza', details: 'Dhankar Monastery, Dhankar Lake trek, Pin Valley visit. Overnight Kaza.' },
      { title: 'Kaza Local: Key, Kibber, Hikkim', details: 'Key Monastery, world\u2019s highest post office at Hikkim, Langza fossil village, Chicham Bridge.' },
      { title: 'Kaza to Manali via Kunzum & Chandratal', details: 'Kunzum Pass, Chandratal Lake, Rohtang Pass, Atal Tunnel to Manali.' },
      { title: 'Manali to Departure', details: 'Drive to Chandigarh/Delhi for departure.' },
    ]),
  },
  {
    id: 'sikkim-yumthang',
    title: 'Sikkim Yumthang Valley',
    duration: '5N/6D',
    category: 'Hills & Adventure',
    highlights: 'Gangtok • Lachung • Yumthang Zero Point • Rhododendron Valley',
    inclusions: ['Hotels', 'Cab', 'Permits'],
    image: 'https://images.unsplash.com/photo-1674922049190-f631ba5bc44f',
    priceFrom: 19999,
    itinerary: makeItinerary([
      { title: 'NJP to Gangtok', details: 'Pickup from Bagdogra/NJP. Drive to Gangtok. MG Marg walk.' },
      { title: 'Gangtok Local', details: 'Rumtek, Enchey, Namgyal Institute of Tibetology, Do Drul Chorten, Ropeway.' },
      { title: 'Gangtok to Lachung', details: 'Long scenic drive (120 km / 6 hrs) via Seven Sisters Waterfall, Naga Falls, Bhim Nala Falls.' },
      { title: 'Yumthang Valley & Zero Point', details: 'Excursion to Valley of Flowers (Yumthang) and Zero Point (Yumesamdong 15,300 ft \u2013 seasonal). Return Lachung.' },
      { title: 'Lachung to Gangtok / Tsomgo', details: 'Return to Gangtok. Half-day Tsomgo Lake & Baba Mandir option.' },
      { title: 'Departure via NJP', details: 'Drive down for train/flight.' },
    ]),
  },
  {
    id: 'wayanad-kerala',
    title: 'Wayanad Nature Escape',
    duration: '3N/4D',
    category: 'South India',
    highlights: 'Edakkal Caves • Banasura Dam • Chembra Peak • Soochipara Falls',
    inclusions: ['Resort', 'Cab', 'Breakfast'],
    image: 'https://images.unsplash.com/photo-1575305327780-a887f284432f',
    priceFrom: 12999,
    itinerary: makeItinerary([
      { title: 'Arrival Wayanad', details: 'Pickup from Kozhikode/Kalpetta. Resort check-in. Pookode Lake evening.' },
      { title: 'Edakkal & Banasura', details: 'Edakkal caves (Neolithic), Banasura Sagar Dam boating.' },
      { title: 'Chembra Peak & Falls', details: 'Chembra Peak heart-shaped lake trek. Soochipara / Meenmutty Falls.' },
      { title: 'Departure', details: 'Muthanga wildlife safari (optional). Drop.' },
    ]),
  },
  {
    id: 'hampi-badami',
    title: 'Hampi Heritage',
    duration: '3N/4D',
    category: 'South India',
    highlights: 'Virupaksha Temple • Vittala Stone Chariot • Lotus Mahal • Anegundi',
    inclusions: ['Hotel', 'Cab', 'Guide'],
    image: 'https://images.unsplash.com/photo-1722934804353-0d9f6a55ab5e',
    priceFrom: 11999,
    itinerary: makeItinerary([
      { title: 'Arrival Hospet / Hampi', details: 'Pickup from Hospet station. Evening walk at Virupaksha Temple.' },
      { title: 'Sacred Centre Sightseeing', details: 'Virupaksha, Hemakuta Hills, Krishna Temple, Lakshmi Narasimha & Badavilinga.' },
      { title: 'Royal Centre & Vittala', details: 'Vittala Temple stone chariot, Lotus Mahal, Elephant Stables, Queen\u2019s Bath, Hazara Rama Temple.' },
      { title: 'Anegundi & Departure', details: 'Anegundi ancient village, Coracle boat ride on Tungabhadra. Drop.' },
    ]),
  },
  // ---- NEPAL PACKAGES ----
  {
    id: 'kathmandu-pokhara',
    title: 'Kathmandu\u2013Pokhara (Nepal)',
    duration: '5N/6D',
    category: 'Nepal',
    highlights: 'Pashupatinath \u2022 Boudhanath \u2022 Swayambhunath \u2022 Phewa Lake \u2022 Sarangkot Sunrise',
    inclusions: ['Hotels', 'Cab', 'Guide', 'Breakfast'],
    image: 'https://images.unsplash.com/photo-1648298470994-7065f521375c',
    priceFrom: 21999,
    itinerary: makeItinerary([
      { title: 'Arrival Kathmandu', details: 'Airport pickup at TIA. Evening Thamel walk & welcome dinner with cultural show.' },
      { title: 'Kathmandu Temples', details: 'Pashupatinath Aarti, Boudhanath Stupa, Swayambhunath (Monkey Temple), Kathmandu Durbar Square.' },
      { title: 'Kathmandu to Pokhara', details: 'Scenic drive (200 km / 7 hrs) OR flight option. Evening Phewa Lake boating & Tal Barahi Temple.' },
      { title: 'Sarangkot Sunrise & Pokhara Sightseeing', details: 'Early Sarangkot sunrise over Annapurna range. Davis Falls, Gupteshwor Cave, Bindhyabasini Temple, Peace Pagoda.' },
      { title: 'Pokhara to Kathmandu', details: 'Return drive/flight. Patan Durbar Square evening.' },
      { title: 'Departure', details: 'Airport drop.' },
    ]),
  },
  {
    id: 'muktinath-yatra',
    title: 'Muktinath Yatra (Nepal)',
    duration: '7N/8D',
    category: 'Nepal',
    highlights: 'Muktinath Dham \u2022 Jomsom \u2022 Kagbeni \u2022 Pokhara \u2022 Kathmandu Pashupatinath',
    inclusions: ['Hotels', 'Cab', 'Flight Pokhara-Jomsom', 'Guide'],
    image: 'https://images.unsplash.com/photo-1761900936681-9b68c0b45c57',
    priceFrom: 32999,
    itinerary: makeItinerary([
      { title: 'Gorakhpur / Kathmandu Arrival', details: 'Meet at Sonauli border OR Kathmandu airport. Overnight Kathmandu.' },
      { title: 'Kathmandu Temples', details: 'Pashupatinath Aarti, Boudhanath, Swayambhunath, Guhyeshwari Shakti Peeth.' },
      { title: 'Kathmandu to Pokhara', details: 'Drive to Pokhara (200 km) OR flight. Evening Phewa lake.' },
      { title: 'Pokhara to Jomsom to Muktinath', details: 'Early flight to Jomsom. Jeep to Muktinath (3,800m). Darshan of Muktinath Ji, 108 water spouts. Overnight Jomsom.' },
      { title: 'Return to Pokhara', details: 'Flight Jomsom-Pokhara. Sarangkot / Davis Falls / Gupteshwor Cave.' },
      { title: 'Pokhara to Kathmandu', details: 'Return drive/flight. Patan Durbar Square.' },
      { title: 'Manokamana / Reserve', details: 'Manokamana Devi Temple via cable car OR relax in Thamel.' },
      { title: 'Departure', details: 'Airport / border drop.' },
    ]),
  },
  {
    id: 'lumbini-janakpur',
    title: 'Lumbini\u2013Janakpur Buddhist (Nepal)',
    duration: '4N/5D',
    category: 'Nepal',
    highlights: 'Mayadevi Temple \u2022 Ashoka Pillar \u2022 World Peace Pagoda \u2022 Janaki Mandir',
    inclusions: ['Hotels', 'Cab', 'Guide'],
    image: 'https://images.unsplash.com/photo-1614939188731-79bbf44e18ef',
    priceFrom: 15999,
    itinerary: makeItinerary([
      { title: 'Sonauli / Gorakhpur to Lumbini', details: 'Pickup, cross Sonauli border. Drive to Lumbini. Evening at monastic zone.' },
      { title: 'Lumbini Sightseeing', details: 'Mayadevi Temple (Buddha\u2019s birthplace), Ashoka Pillar, sacred pond, World Peace Pagoda, Chinese/Thai/Japanese monasteries.' },
      { title: 'Lumbini to Janakpur', details: 'Drive to Janakpur (270 km). Evening Janaki Mandir aarti.' },
      { title: 'Janakpur Darshan', details: 'Janaki Mandir, Ram Mandir, Ganga Sagar & Dhanush Sagar, Ram Sita Vivah Mandap.' },
      { title: 'Departure', details: 'Drop back to Sonauli / Gorakhpur / Patna.' },
    ]),
  },
  {
    id: 'everest-base-camp',
    title: 'Everest Base Camp Trek (Nepal)',
    duration: '13N/14D',
    category: 'Nepal',
    highlights: 'Lukla \u2022 Namche Bazaar \u2022 Tengboche \u2022 Gorak Shep \u2022 Kala Patthar \u2022 EBC 5,364m',
    inclusions: ['Teahouses', 'Guide', 'Porter', 'Permits', 'Meals'],
    image: 'https://images.unsplash.com/photo-1676471049029-f93852da351d',
    priceFrom: 89999,
    itinerary: makeItinerary([
      { title: 'Kathmandu Arrival', details: 'Airport pickup. Trek briefing. Overnight Kathmandu.' },
      { title: 'Fly to Lukla, Trek to Phakding', details: 'Early flight to Lukla (2,860m). Trek 3 hrs to Phakding (2,610m).' },
      { title: 'Phakding to Namche Bazaar', details: 'Trek 6 hrs to Namche (3,440m) crossing Dudh Kosi river.' },
      { title: 'Namche Acclimatization', details: 'Rest day. Hike to Everest View Hotel & Khumjung village. First Everest views.' },
      { title: 'Namche to Tengboche', details: 'Trek 5 hrs to Tengboche (3,860m). Famous Tengboche Monastery.' },
      { title: 'Tengboche to Dingboche', details: 'Trek 5 hrs to Dingboche (4,410m).' },
      { title: 'Dingboche Acclimatization', details: 'Rest day. Hike to Nangkartshang Peak (5,083m).' },
      { title: 'Dingboche to Lobuche', details: 'Trek 5 hrs via Thukla Pass memorials to Lobuche (4,940m).' },
      { title: 'Lobuche to EBC via Gorak Shep', details: 'Trek to Gorak Shep (5,164m). Continue to Everest Base Camp (5,364m). Return Gorak Shep.' },
      { title: 'Kala Patthar & Trek Down', details: 'Sunrise Kala Patthar (5,545m) \u2013 best Everest view. Descend to Pheriche.' },
      { title: 'Pheriche to Namche', details: 'Long trek back to Namche (6-7 hrs).' },
      { title: 'Namche to Lukla', details: 'Final trek day to Lukla (7 hrs).' },
      { title: 'Lukla to Kathmandu Flight', details: 'Morning flight. Free evening for celebration dinner.' },
      { title: 'Departure', details: 'Airport drop.' },
    ]),
  },
];

export const vehicles = [
  { name: 'Swift Dzire', desc: '4 Seater • Sedan • Ideal for couples & small families', image: 'https://upload.wikimedia.org/wikipedia/commons/e/e7/Maruti_Suzuki_Swift_Dzire_%28cropped%29.jpg' },
  { name: 'Ertiga', desc: '6–7 Seater • MPV • Perfect for family trips', image: 'https://upload.wikimedia.org/wikipedia/commons/3/3e/2025_Maruti_Suzuki_Ertiga_VXi_S-CNG.png' },
  { name: 'Kia Carens', desc: '6–7 Seater • Premium MPV • Spacious & modern', image: 'https://upload.wikimedia.org/wikipedia/commons/b/b6/Kia_Carens_2024_Model.jpg' },
  { name: 'Innova Crysta', desc: '7 Seater • Most popular • Comfort & reliability', image: 'https://upload.wikimedia.org/wikipedia/commons/8/87/Toyota_Innova_Crysta_2.4_Z_front_right.jpg' },
  { name: 'Force Urbania', desc: '9–17 Seater • Luxury Van • Premium group travel', image: 'https://upload.wikimedia.org/wikipedia/commons/5/5b/Iveco_eDaily%2C_Busworld_Europe_2023%2C_Brussels_%28P1140027%29.jpg' },
  { name: 'Tempo Traveller', desc: '12 / 17 / 20 Seater • Group tours & yatras', image: 'https://upload.wikimedia.org/wikipedia/commons/4/43/Force_Traveller_Luxury.jpg' },
  { name: 'Mini Bus', desc: '20–30 Seater • School & corporate groups', image: 'https://upload.wikimedia.org/wikipedia/commons/8/88/Scania_Metrolink_HD_14.5_M_Ashwamedh.jpg' },
  { name: 'Luxury Coach', desc: '35–45 Seater • Long distance & premium groups', image: 'https://upload.wikimedia.org/wikipedia/commons/9/95/Volvo_9700_6x2_-_Front_and_left_side_IAA_2018.jpg' },
];

export const testimonials = [
  { name: 'Rahul Sharma', location: 'Delhi', rating: 5, text: 'Our Char Dham Yatra was flawless. Well-planned stops, clean hotels & experienced driver. Highly recommend Goodwishes India Tours!' },
  { name: 'Anita Verma', location: 'Mumbai', rating: 5, text: 'Kashmir trip was a dream come true. Excellent shikara experience and Gulmarg gondola arranged smoothly.' },
  { name: 'Vikram Singh', location: 'Lucknow', rating: 5, text: 'Ayodhya darshan was smooth and hassle-free. VIP darshan was managed excellently by the team.' },
  { name: 'Priya Nair', location: 'Bangalore', rating: 5, text: 'Kerala backwaters houseboat was heavenly. Prompt WhatsApp support 24x7. Very professional team.' },
  { name: 'Amit Kumar', location: 'Patna', rating: 5, text: 'Best Varanasi package with Ganga Aarti reserved seat. Guide was very knowledgeable. Will book again!' },
  { name: 'Sneha Gupta', location: 'Kolkata', rating: 5, text: 'Rajasthan circuit was memorable. Desert camp night at Jaisalmer was magical. Great price too.' },
];

export const stats = [
  { value: '2,000+', label: 'Happy Travellers' },
  { value: '45+', label: 'Destinations' },
  { value: '12+', label: 'Years of Experience' },
  { value: '4.9★', label: 'Google Rating' },
];
